import React from 'react';
import ProgressiveImage from 'react-progressive-image';
import { getTheBestImageFormat } from '../../utils/common';
import CloseModalButton from '../../common/Modal/Buttons/CloseModalButton';

export default function Modal(props) {
	return (
		<div className='project-popup '>
			<h1 className='project-popup__title '>Gllacy Shop</h1>
			<p className='project-popup__description '>
				Another HTML &amp; CSS project from HTML Academy Courses. It includes two
				pages: index.html and catalog.html. The project is not responsive, but the
				design is awe-inspiring :)
			</p>
			<div className='project-popup__about '>
				<p>
					<span className='span-title '>Stack:</span>
					<span className='span-description '>
						HTML, CSS, JavaScript, Google maps
					</span>
				</p>
			</div>
			<div className='project-popup__images '>
				<p className='image-description '>index.html</p>

				<ProgressiveImage
					src={getTheBestImageFormat({
						webp: './media/projects/gllacy/1.webp',
						backupImage: './media/projects/gllacy/1.png',
					})}
					placeholder='./media/loader.gif'
				>
					{(src) => <img src={src} alt='gllacy-image1' className='no-margin-img' />}
				</ProgressiveImage>

				<ProgressiveImage
					src={getTheBestImageFormat({
						webp: './media/projects/gllacy/2.webp',
						backupImage: './media/projects/gllacy/2.png',
					})}
					placeholder='./media/loader.gif'
				>
					{(src) => <img src={src} alt='gllacy-image2' className='no-margin-img' />}
				</ProgressiveImage>

				<ProgressiveImage
					src={getTheBestImageFormat({
						webp: './media/projects/gllacy/3.webp',
						backupImage: './media/projects/gllacy/3.png',
					})}
					placeholder='./media/loader.gif'
				>
					{(src) => <img src={src} alt='gllacy-image3' />}
				</ProgressiveImage>

				<p className='image-description '>catalog.html</p>

				<ProgressiveImage
					src={getTheBestImageFormat({
						webp: './media/projects/gllacy/4.webp',
						backupImage: './media/projects/gllacy/4.png',
					})}
					placeholder='./media/loader.gif'
				>
					{(src) => <img src={src} alt='gllacy-image4' className='no-margin-img' />}
				</ProgressiveImage>

				<ProgressiveImage
					src={getTheBestImageFormat({
						webp: './media/projects/gllacy/5.webp',
						backupImage: './media/projects/gllacy/5.png',
					})}
					placeholder='./media/loader.gif'
				>
					{(src) => <img src={src} alt='gllacy-image5' className='no-margin-img' />}
				</ProgressiveImage>
			</div>
			<div className='project-popup__buttons '>
				<a
					href='https://slava-nik.github.io/Gllacy/index.html'
					className='project-link '
					target='_blank'
					rel='noopener noreferrer'
				>
					Visit project
				</a>
				<CloseModalButton onClose={props.closeModal} />
			</div>
		</div>
	);
}
